import { formatDate } from '@angular/common';

export class DateRange {
  dateRangeType: string = "";
  startDate: Date = new Date(0);
  endDate: Date = new Date(0);

  public toString(): string {
    if (this.startDate && this.endDate) {
      return formatDate(this.startDate, "dd MMM yyyy", "en")
        + " - " + formatDate(this.endDate, "dd MMM yyyy", "en");
    }
    return "";
  }
}
